import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import React from 'react';
import { Controller, ControllerProps, FieldError } from "react-hook-form";

interface Props {
    name: string;
    rules?: ControllerProps["rules"];
    control: ControllerProps["control"];
    error?: FieldError;
    isDefaultChecked?: boolean;
    onChecked?: any;
    formLabelStyle?: React.CSSProperties
}

const CustomCheckBox = React.memo((props: Props & CheckboxProps & Omit<FormControlLabelProps, 'control'>) => {
    const { control, name, rules, isDefaultChecked, onChecked, error, formLabelStyle = {}, ...rest } = props;

    return (
        <FormControlLabel
            style={{ width: "fit-content", fontSize: 14, ...formLabelStyle }}
            control={
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    defaultValue={isDefaultChecked ?? false}
                    render={({ field }) => (
                        <Checkbox
                            name={name}
                            checked={!!field.value}
                            color="primary"
                            size="small"
                            {...rest}
                            onChange={(e) => { field.onChange(e.target.checked); if (onChecked) onChecked(e.target.checked) }}
                        />
                    )}
                />
            }
            {...rest}
        />
    )
});

const CheckBox = React.memo((props: CheckboxProps & { label?: string, formLabelStyle?: React.CSSProperties }) => {
    const { label = "", formLabelStyle = {}, ...rest } = props;

    return (
        <FormControlLabel
            style={{ width: "fit-content", ...formLabelStyle }}
            control={
                <Checkbox
                    size="medium"
                    color="primary"
                    {...rest}
                />
            }
            label={label}
        />
    )
});

export { CustomCheckBox, CheckBox };